import { useApi } from "@/api";
import { ContentType, TTransaction } from "@/api/v1_0";
import { RootStore } from "@/store/root";
import { TTransactionsMap } from "@/types";
import endOfMonth from "date-fns/endOfMonth";
import format from "date-fns/format";
import startOfMonth from "date-fns/startOfMonth";
import { makeAutoObservable } from "mobx";

export class HistoryStore {
  private _rootStore: RootStore;

  public loading = false;
  public refreshing = false;

  public date: Date = new Date();
  public transactions: TTransactionsMap = new Map<
    TTransaction["uuid"],
    TTransaction
  >();

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;

    makeAutoObservable(this);
  }

  public load = async (): Promise<void> => {
    this._rootStore.logging.track("history.load", { date: this.date });

    try {
      this.loading = true;

      const api = useApi();

      const { data: result } =
        await api.v10.appHttpApiV10ControllerWalletTransactionsRead(
          {
            end: format(endOfMonth(this.date), "yyyy-MM-dd"),
            start: format(startOfMonth(this.date), "yyyy-MM-dd"),
          },
          {
            headers: {
              Accept: ContentType.Json,
              "Content-Type": ContentType.Json,
            },
          }
        );

      this.transactions = result.items.reduce(
        (transactions, transaction) =>
          transactions.set(transaction.uuid, transaction),
        new Map<TTransaction["uuid"], TTransaction>()
      );
    } catch (err) {
      throw this._rootStore.logging.capture(err);
    } finally {
      this.loading = false;
    }
  };

  public refresh = async (): Promise<void> => {
    try {
      this.refreshing = true;

      await this.load();
    } finally {
      this.refreshing = false;
    }
  };
}
